<template>
  <tr>
    <td class="text-center p-3">
      <strong style="font-size: 16px">{{
        $t('common_words.total_mayus')
      }}</strong>
    </td>
    <template v-for="ribbonData in getColumns()">
      <template v-for="ribbon in ribbonData">
        <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
          {{ ribbon.pocket }}
        </td>
        <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
          {{ ribbon.cutting }}
        </td>
        <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
          {{ ribbon.ringing }}
        </td>
        <td class="text-center">
          {{ ribbon.balance }}
        </td>
        <percent-cell-balance
          :value="ribbon.balance"
          :percent="ribbon.percent"
        />
      </template>
    </template>
  </tr>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import PercentCellBalance from '../Layouts/PercentCellBalance.vue';

export default {
  name: 'tfoot-totals',
  components: {
    [PercentCellBalance.name]: PercentCellBalance,
  },
  props: {
    totalColumns: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'ribbonsBalances',
    },
  },
  mixins: [MixinMasters],
  methods: {
    getColumns() {
      const cols = Object.keys(this.columns).map((week) => {
        return this.columns[week].map((ribbon) => {
          const values = this.getTotalColumn(week, ribbon.color_name);
          return {
            ...ribbon,
            balance: values[0],
            percent: values[1],
            pocket: values[2],
            cutting: values[3],
            ringing: values[4],
          };
        });
      });
      return cols;
    },

    getTotalColumn(week, ribbon) {
      const pocket = this.getSumByType('pocket', week, ribbon);
      const cutting = this.getSumByType('cutting', week, ribbon);
      const ringing = this.getSumByType('ringing', week, ribbon);
      const total = pocket - cutting - ringing;
      const totalReponse = 1 - total / pocket;
      let percent = '';

      if (Number(total) === 0) percent = '100%';
      else if (Number(pocket) === 0) percent = '0%';
      else
        percent =
          totalReponse == 0
            ? '0%'
            : `${Formatter.formatNumber((totalReponse * 100).toFixed(2))}%`;

      return [
        Formatter.formatNumber(total),
        percent,
        Formatter.formatNumber(pocket),
        Formatter.formatNumber(cutting),
        Formatter.formatNumber(ringing),
      ];
    },

    getSumByType(type, week, ribbon) {
      try {
        const filtered = this.totalColumns[type][week][ribbon];
        return Array.isArray(filtered)
          ? getSumOfValorFromArray(filtered)
          : getSumOfValorFromArray(Object.values(filtered));
      } catch (error) {
        return 0;
      }
    },
  },
};
</script>
